<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title d-flex align-items-center justify-content-between">
          <span><i class="fas fa-file-invoice-dollar me-2"></i> {{ wizardTitle }}</span>
        </h4>
      </div>
      <div class="card-body">
        @if (submittedDate) {
          <div class="alert alert-success mb-3" role="alert">
            <i class="fas fa-check-circle me-2"></i>
            This {{ wizardTitle }} was submitted successfully on {{ submittedDate | date:'medium' }}.
            @if (formModel?.generatedDocument?.documentType?.documentTypeName) {
              The document can be found in Loan Docs under "{{ formModel.generatedDocument.documentType.documentTypeName }}".
            }
          </div>
        }

        @if (hasLoadError) {
          <div class="alert alert-danger mb-3" role="alert">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ loadErrorMessage }}
          </div>
        }

        @if (!hasLoadError) {
          <loda-stepper-v2 [activeStepIndex]="activeStepIndex" [steps]="transformedSteps"></loda-stepper-v2>
        }

        <div class="wizard-content mt-4" [ngStyle]="{'min-height': '400px'}">
          @if (isLoadingData) {
            <div class="text-center py-5">
              <span class="spinner-border spinner-border-lg" role="status"></span>
              <p class="mt-2">Loading form data...</p>
            </div>
          }

          @if (!isLoadingData && !hasLoadError) {
            <fieldset [disabled]="isReadOnly" class="border-0 p-0 m-0 w-100">
            <div [hidden]="activeStepIndex !== 0">
              <broker-information #brokerInfoStep
                [brokerInformation]="formModel?.brokerInformation"
                [willSnapDocsBeUsed]="formModel?.willSnapDocsBeUsed ?? null"
                [isHybridClosing]="formModel?.isHybridClosing ?? null">
              </broker-information>
            </div>
            <div [hidden]="activeStepIndex !== 1">
              <property-information #propertyInfoStep
                [propertyInformation]="formModel?.propertyInformation">
              </property-information>
            </div>
            <div [hidden]="activeStepIndex !== 2">
              <loan-information #loanInfoStep
                [loanInformation]="formModel?.loanInformation">
              </loan-information>
            </div>
            <div [hidden]="activeStepIndex !== 3">
                <doc-order-fees #docOrderFeesStep
                  [fees]="formModel?.fees">
                </doc-order-fees>
            </div>
            <div [hidden]="activeStepIndex !== 4">
              <seller-agent #sellerAgentStep
                [sellerRealEstateAgent]="formModel?.sellerRealEstateAgent"
                [noSellerRealEstateAgentUsed]="formModel?.noSellerRealEstateAgentUsed">
              </seller-agent>
            </div>
            <div [hidden]="activeStepIndex !== 5">
              <buyer-agent #buyerAgentStep
                [buyerRealEstateAgent]="formModel?.buyerRealEstateAgent"
                [noRealEstateAgentUsed]="formModel?.noRealEstateAgentUsed">
              </buyer-agent>
            </div>
            <div [hidden]="activeStepIndex !== 6">
              <title-information-step #titleInfoStep
                [titleInformation]="formModel?.titleInformation"
                [copySourceProvider]="this">
              </title-information-step>
            </div>
            <div [hidden]="activeStepIndex !== 7">
              <escrow-information #escrowInfoStep
                [escrowInformation]="formModel?.escrowInformation"
                [copySourceProvider]="this">
              </escrow-information>
            </div>
            <div [hidden]="activeStepIndex !== 8">
              <settlement-agent #settlementAgentStep
                [settlementInformation]="formModel?.settlementInformation"
                [copySourceProvider]="this">
              </settlement-agent>
            </div>
            <div [hidden]="activeStepIndex !== 9">
              <additional-comments #additionalCommentsStep [parentWizard]="this"></additional-comments>
            </div>
            </fieldset>
          }
        </div>

        @if (!isLoadingData && !hasLoadError) {
        <div class="wizard-navigation d-flex justify-content-center mt-4">
          <button
            type="button"
            class="btn btn-primary me-2"
            [disabled]="atFirstStep || isStepRunning"
            (click)="navigateBackward()">
            <i class="fas fa-arrow-left me-1"></i> Back
          </button>
          @if (!atLastStep) {
            <button
              type="button"
              class="btn btn-primary me-2"
              [disabled]="isStepRunning || disableNextButton"
              (click)="navigateForward()">
              @if (isStepRunning) {
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              }
              {{ isStepRunning ? 'Please wait...' : nextButtonLabel }}
              @if (!isStepRunning) {
                <i class="fas fa-arrow-right ms-1"></i>
              }
            </button>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>
